/**
 * Created by Admin on 2019/2/15.
 */
import { Toast } from "mint-ui";
import { getQueryString, runChannel, h5toSysWeb } from "./common"
export default {
  install(Vue, options) {
    const deviceType = Vue.prototype.config.system;
    Vue.prototype.app = {
      //关闭用户中心
      closeUserCenter(params) {
        // params 用于游戏盒子引流弹窗控制显示
        console.log("Vue.prototype.app deviceType = ", deviceType)
        if (deviceType === 1) {
          window.Android.finish();
        } else if (deviceType === 2) {
          window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'wz_close_user_center' });
        } else if (deviceType === 5) {
          // console.log('params', params);
          window.parent.postMessage({ method: 'closeUserCenter', showDividend: params }, '*')
        }
      },

      // 看视频广告
      CallApiCloud(any) {
        // console.log('CallApiCloud wzSDK');
        // console.log("Vue.prototype.app deviceType = ", deviceType)
        var u = navigator.userAgent,
          app = navigator.appVersion;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          console.log('安卓 111111111111111111111111111111111111');
          // window.AndroidJs.callStaticMethod(any);
          if (window.AndroidJs) window.AndroidJs.callStaticMethod(any);
          else window.Android.callStaticMethod(any);
        } else if (isIOS) {
          console.log('IOS 2222222222222222222222222222222222222');
          try {

            if (window.webkit.messageHandlers.callStaticMethod) {
              window.webkit.messageHandlers.callStaticMethod.postMessage(any);
              // if(getQueryString('channel') == 'xgame40' || getQueryString('channel') == 'test'){
              //   console.log( JSON.parse(any),'看广告' );
              //   window.webkit.messageHandlers.callStaticMethod.postMessage(JSON.parse(any));
              // }else{
              //   window.webkit.messageHandlers.callStaticMethod.postMessage(any);
              // }

            } else {
              Toast('暂无')
            }
          } catch (err) {
            Toast('暂无')
          }
        } else {
          console.log('其他 3333333333333333333333333333');
        }

      },
      //打开游戏盒子
      openBox() {
        if (deviceType === 1) {
          window.Android.openBox();
        } else if (deviceType === 2) {
          window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'wz_open_box' });
        }
      },
      // 捕鱼
      openFishing() {
        console.log('-openFishing--',runChannel(1),);
        if (runChannel(1)) {
          window.AndroidJs &&( window.AndroidJs.tabChange("捕鱼") )
          window.Android && (window.Android.tabChange("捕鱼"))
        } else if (runChannel(2)) {
          Toast('暂无游戏')
          // window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'wz_open_box' });
        }
      },
      //进入申请返利
      openRebate() {
        if (deviceType === 1) {
          window.Android.applyForRebate();
        } else if (deviceType === 2) {
          window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'wz_show_rebate_view' });
        }
      },
      //隐藏悬浮球
      hideFloat() {
        if (deviceType === 1) {

          window.Android.hideBall();
        } else if (deviceType === 2) {
          window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'wz_close_float' });
        } else if (deviceType === 5) {
          window.parent.postMessage({ method: 'hideFloat' }, '*')
        }
      },
      //设置悬浮球文字
      showFloatLabel(message) {
        message = message || '';
        if (deviceType === 1) {
          window.Android.showHideBallDialog(message);
        } else if (deviceType === 2) {
          window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'wz_set_float_label_text' });
        }
      },
      //退出登录
      logout() {
        if (deviceType === 1) {
          window.Android.logout();
        } else if (deviceType === 2) {
          window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'wz_logout' });
        } else if (deviceType === 5) {
          window.parent.postMessage({ method: 'logout' }, '*')
        }
      },
      // 竖版 退出登录
      verticalLogout() {
        // 由于ios 竖版审核,走的非sdk, 需要特殊处理
        if (getQueryString('isNoticeIos') == 1) {
          window.webkit.messageHandlers.vertical_logout.postMessage({ method: 'vertical_logout' });
          return
        }
        if (deviceType === 1) {
          window.Android.logout();
        } else if (deviceType === 2) {
          window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'vertical_logout' });
        } else if (deviceType === 5) {
          window.parent.postMessage({ method: 'logout' }, '*')
        }
      },
      //退出登录
      goBackHome() {
        if (deviceType === 1) {
          // window.Android.logout();
        } else if (deviceType === 2) {
          // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_logout'});
        } else if (deviceType === 5) {
          window.parent.postMessage({ method: 'goBackHome' }, '*')
        }
      },
      //跳外部链接
      openUrl(url) {
        // console.log(url)
        // console.log('wz_enable_bg_tap_gesture')
        if (deviceType === 1) {
          return window.Android.openUrl(url);
        } else if (deviceType === 2) {
          window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'wz_enable_bg_tap_gesture' });
          window.location.href = url;
        } else if (deviceType === 5) {
          window.parent.postMessage({ method: 'openUrl', url: url, withclose: true }, '*')
        }
      },
      //跳外部链接
      openUrlNew(url) {
        if (deviceType === 1) {
          // return window.Android.openUrl(url);
          // 安卓包 打开链接 再关闭侧滑
          window.location.href = url;
          window.Android.finish();
        } else if (deviceType === 2) {
          // window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'wz_enable_bg_tap_gesture' });
          window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'wz_close_user_center' });
          window.location.href = url;
        } else if (deviceType === 5) {
          window.parent.postMessage({ method: 'openUrl', url: url, withclose: true }, '*')
        }
      },
      //清除网页缓存（非cookie）
      cleanWebCaches() {
        if (getQueryString('isNoticeIos') == 1) {
          window.webkit.messageHandlers.wz_cleanCaches.postMessage({ method: 'wz_cleanCaches' });
          return
        }
        if (deviceType === 1) {
          return window.Android.wz_cleanCaches();
        } else if (deviceType === 2) {
          window.webkit.messageHandlers.wz_callOC.postMessage({ method: 'wz_cleanCaches' });
        } else if (deviceType === 5) {
          window.parent.postMessage({ method: 'cleanWebCaches' }, '*')
        }
      },
      //跳qq群
      startQQGroup(groupKey) {
        if (deviceType === 1) {
          return window.Android.startQQGroup(groupKey);
        } else if (deviceType === 2) {
          // return window.location.href = url;
          // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_close_user_center'});
        }
      },
      //复制礼包码
      copy(content) {
        content = content || '';
        if (deviceType === 1) {
          window.Android.copyToClipboard(content);
        } else if (deviceType === 2) {
          // window.webkit.messageHandlers.wz_callOC.postMessage({method : 'wz_logout'});
        }
      },
      //跳转到商城
      jumpShop() {
        window.parent.postMessage({ method: "goBackShop" }, '*')
      },
      //跳转到分红池
      jumpFenhongchi() {
        window.parent.postMessage({ method: "goBackFenhongchi" })
      },
      //跳转到仓库
      jumpCangku() {
        window.parent.postMessage({ method: "goBackCangku" })
      },
      // 跳转等级活动（Vue跳转）
      toLevelActivityByVue() {
        window.parent.postMessage({ method: "goLevelActivityByVue" })
      },
      // 跳转等级活动（APP跳转支持）
      toLevelActivity() {
        console.log('window2', window);
        let params = {
          type: 2 // 2为跳转红包瓜分
        }
        if (window.AndroidJs) {
          console.log('isAndroid app', 'callStaticNavigationGameMethod');
          window.AndroidJs.callStaticNavigationGameMethod(JSON.stringify(params));
        } else if (window.webkit) {
          console.log('isIOS app');
          window.webkit.messageHandlers.callStaticNavigationGameMethod.postMessage(JSON.stringify(params));
        } else {
          console.log('isweb', window.location.hostname);
          let hostname = window.location.hostname;
          if (hostname == 'localhost') {
            hostname = 'v4.h5.haowusong.com';
          }
          window.location.href = `https://${hostname}/box/sdk/Personalcenter`;
        }
      },
      // 分享好友
      InviteFriend(any) {
        var u = navigator.userAgent,
          app = navigator.appVersion;
        let data = JSON.parse(JSON.stringify(any))
        console.log("asdjaksdjakdjalskdjjklad");
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          console.log("安卓 111111111111111111111111111111111111");
          if (window.AndroidJs) {
            window.AndroidJs.callNativeShareImg2Wx(JSON.stringify({ "bgImg": `${data.share_bg}`, "qrContent": `${data.share_url}` }));
            window.AndroidJs.callNativeShareQc2Wx(JSON.stringify(data));
          }
        } else if (isIOS) {
          console.log("IOS 2222222222222222222222222222222222222");
          if (window.webkit) {
            window.webkit.messageHandlers.callNativeShareQc2Wx.postMessage(JSON.stringify(data));
            // if(getQueryString('channel') == 'xgame40' || getQueryString('channel') == 'test'){
            //   console.log('---InviteFriend');
            //   window.webkit.messageHandlers.callNativeShareQc2Wx.postMessage(data);
            // }else{
            //   window.webkit.messageHandlers.callNativeShareQc2Wx.postMessage(JSON.stringify(data));
            // }

          }
        } else {
          console.log("其他 3333333333333333333333333333");
        }
      },
      //跳外部网页
      BlindBoxherf(url) {
        console.log(url);
        if (deviceType === 1) {
          window.dysdk.openBrowser(url)
          // window.h5toSysWeb(url)
        } else if (deviceType === 2) {
          window.location.href = url
        } else if (deviceType === 5) {
          if (runChannel(1)) {
            window.dysdk.openBrowser(url)
            // h5toSysWeb(url)
          } else if (runChannel(2)) {
            window.location.href = url
          }
          else {
          }
        }
      },
      //跳tarbard底部
      // BlindBoxherf(url,type="福袋") {
      //   console.log(url);
      //   if (deviceType === 1) {
      //     window.Android.tabChange(type);
      //     // window.h5toSysWeb(url)
      //   } else if (deviceType === 2) {
      //     window.location.href = url
      //   } else if (deviceType === 5) {
      //     if (runChannel(1)) {
      //       window.Android.tabChange(type);
      //       // h5toSysWeb(url)
      //     } else if (runChannel(2)) {
      //       window.location.href = url
      //     }
      //     else {
      //     }
      //   }
      // },
      //跳tarbard底部
      goAppTarbar(type) {
        console.log(type,deviceType);
        if (deviceType === 1) {
          window.Android.tabChange(type);
        } else if (deviceType === 2) {

        } else if (deviceType === 5) {
          if (runChannel(1)) {
            window.Android.tabChange(type);
            console.log(2);

          } else if (runChannel(2)) {

          }
          else {
          }
        }
      },
    }
  },


};

// WEBPACK FOOTER //
// ./src/static/js/wzSDK.js



// WEBPACK FOOTER //
// ./src/static/js/wzSDK.js